<aside class="side-menu-container"  [class.collapsed]="isSideMenuCollapsed()">
  <figure class="logo-figure" [class.collapsed]="isSideMenuCollapsed()">
    <img class="logo-image" src="svgs/app/logo.svg" alt="" />
  </figure>
  <nav class="side-menu-items-container">
    <ul class="side-menu-items" [class.collapsed]="isSideMenuCollapsed()">
      @for(item of sideMenuItems; track $index){
      <li
        class="item"
        [routerLinkActive]="['active']"
        routerLinkActive
        #rla="routerLinkActive"
        [routerLink]="item.route"
        (mouseenter)="itemBeingHovered(item.route)"
        (mouseleave)="itemBeingHovered(null)"
        [appShowFullText]="item.translationPath | translate"
        [exitCondition]="isSideMenuCollapsed() ? false : true"
        [placement]="'common.inline-end' | translate"
      >
        <figure class="item-figure">
          <img
            class="item-image"
            [src]="sideMenuItemIcon(rla.isActive, item)"
            alt="Icon"
          />
        </figure>
        @if(!isSideMenuCollapsed()){
        <p class="item-title">{{ item.translationPath | translate }}</p>
        }
      </li>
      }
    </ul>
  </nav>
</aside>
